module.exports = __webpack_public_path__ + "img/unlock.92b19aad.svg";